import apiClient from "./apiClient";
import { 
  RecoverCredentialDto, 
  RecoverCredentialResponseDto 
} from "../types/recoverCredential";

class RecoverCredentialService {
  async recoverCredentials(
    dto: RecoverCredentialDto
  ): Promise<RecoverCredentialResponseDto> {
    // Σωστό endpoint URL
    const response = await apiClient.post<RecoverCredentialResponseDto>(
      "/RecoverCredential/recover-credential",
      dto
    );

    return response.data || response;
  }
}

const recoverCredentialService = new RecoverCredentialService();
export default recoverCredentialService;